"use client";
import Link from "next/link";
import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";

export default function Footbar() {
  return (
    <footer className="bg-gray-900 text-gray-300 pt-10 pb-6 mt-12">
      <div className="max-w-[1440px] mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">

        {/* --- Brand Section --- */}
        <div>
          <h2 className="text-2xl font-bold text-white mb-4">CHANARAAS</h2>
          <p className="text-sm leading-relaxed mb-4">
            Чанарыг бид амлаж, хэрэглэгч батална. Бид таны амьдралд
            чанартай бүтээгдэхүүн, үйлчилгээ хүргэнэ.
          </p>
          <div className="flex gap-4 mt-4">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-white">
              <FaFacebookF size={18} />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-white">
              <FaInstagram size={18} />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="hover:text-white">
              <FaTwitter size={18} />
            </a>
          </div>
        </div>

        {/* --- Quick Links --- */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-4">Түргэн холбоос</h3>
          <ul className="space-y-2">
            <li><Link href="/review" className="hover:text-white transition">Сэтгэгдэл бичих</Link></li>
            <li><Link href="/blog" className="hover:text-white transition">Блог</Link></li>
          </ul>
        </div>

        {/* --- Services --- */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-4">Үйлчилгээ</h3>
          <ul className="space-y-2">
            <li><Link href="/features" className="hover:text-white transition">Маркетинг</Link></li>
          </ul>
        </div>

        {/* --- Contact --- */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-4">Холбоо барих</h3>
          <ul className="space-y-2 text-sm">
            <li>📍 Улаанбаатар, Монгол</li>
            <li>📞 +976 9688 8660</li>
            <li>✉ chanaraas@gmail.com</li>
          </ul>
        </div>

      </div>

      {/* --- Bottom bar --- */}
      <div className="border-t border-gray-700 mt-8 pt-4 text-center text-sm text-gray-500">
        © {new Date().getFullYear()} Chanaaraas. Бүх эрх хуулиар хамгаалагдсан.
      </div>
    </footer>
  );
}
